var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c("div", [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.rescheduleDialogVisibility
              ? _c("Cancellation", {
                  attrs: { order: _vm.order, type: "rescheduling" },
                  on: {
                    close: function($event) {
                      _vm.rescheduleDialogVisibility = false
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.cancellationDialogVisibility
              ? _c("Cancellation", {
                  attrs: { order: _vm.order, type: "cancellation" },
                  on: {
                    close: function($event) {
                      _vm.cancellationDialogVisibility = false
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.absenceDialogVisibility
              ? _c("Cancellation", {
                  attrs: { order: _vm.order, type: "absence" },
                  on: {
                    close: function($event) {
                      _vm.absenceDialogVisibility = false
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showProofOfPaymentWarning
              ? _c("proof-of-payment-warning", { staticClass: "p-0" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "base-card",
              [
                _c("order-data", {
                  attrs: { order: _vm.order },
                  on: {
                    show: function($event) {
                      _vm.rescheduleDialogVisibility = true
                    }
                  }
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("base-flex", [
                  _vm.showRescheduleButton
                    ? _c(
                        "div",
                        {
                          staticClass: "btn bg-purple-outline",
                          on: {
                            click: function($event) {
                              _vm.rescheduleDialogVisibility = true
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "icon",
                            attrs: { src: "/static/icon_calendar.svg" }
                          }),
                          _vm._v("REAGENDAR\n        ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCancelButton
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.cancellationDialogVisibility = true
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "btn bg-purple-outline" }, [
                            _c("img", {
                              staticClass: "icon",
                              attrs: { src: "/static/icon_cancel.svg" }
                            }),
                            _vm._v("CANCELAR")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAbsenceButton
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.absenceDialogVisibility = true
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "btn bg-purple-outline" }, [
                            _c("img", {
                              staticClass: "icon",
                              attrs: { src: "/static/icon_error.svg" }
                            }),
                            _vm._v("PROFISSIONAL FALTOU")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showRateButton
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.linkRate(),
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c(
                            "base-button",
                            { attrs: { size: "large", outlined: "" } },
                            [_vm._v("avaliar limpeza")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            !_vm.order.cycle_id
              ? _c(
                  "payment-history",
                  { attrs: { payments: _vm.order.payments } },
                  [
                    _c("template", { slot: "header-right" }, [
                      _vm.canGoToCheckout(_vm.order)
                        ? _c(
                            "div",
                            { staticClass: "btn bg-purple" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "order-checkout",
                                      params: { order_id: _vm.order.id }
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            Efetuar pagamento\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-200ed031", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-200ed031","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Index.vue
// module id = null
// module chunks = 